export const CREATE_MEDICINE_COMPOSITIONS = "CREATE_MEDICINE_COMPOSITIONS";
export const RETRIEVE_MEDICINE_COMPOSITIONS = "RETRIEVE_MEDICINE_COMPOSITIONS";
export const RETRIEVESINGLE_MEDICINE_COMPOSITIONS = "RETRIEVESINGLE_MEDICINE_COMPOSITIONS";
export const UPDATE_MEDICINE_COMPOSITIONS = "UPDATE_MEDICINE_COMPOSITIONS";
export const DELETE_MEDICINE_COMPOSITIONS = "DELETE_MEDICINE_COMPOSITIONS";


